import React from 'react';

const escapeText = (value) => String(value ?? '');

function InlineText({ text, attributes = {} }) {
  let content = escapeText(text);
  if (attributes.bold) content = <strong>{content}</strong>;
  if (attributes.italic) content = <em>{content}</em>;
  if (attributes.underline) content = <u>{content}</u>;
  if (attributes.strike) content = <s>{content}</s>;
  return content;
}

// A small React renderer keeps source content safe without injecting HTML.
// It covers the Quill formats offered by the writer toolbar.
export default function DeltaRenderer({ content }) {
  const ops = Array.isArray(content?.ops) ? content.ops : [];
  const lines = [];
  let line = [];
  let lineAttributes = {};

  const flush = () => {
    lines.push({ nodes: line, attributes: lineAttributes });
    line = [];
    lineAttributes = {};
  };

  ops.forEach((op, opIndex) => {
    if (typeof op.insert !== 'string') {
      line.push(<span key={`embed-${opIndex}`}>[embedded content]</span>);
      return;
    }
    const parts = op.insert.split('\n');
    parts.forEach((part, partIndex) => {
      if (part) {
        line.push(
          <InlineText
            key={`${opIndex}-${partIndex}`}
            text={part}
            attributes={op.attributes}
          />,
        );
      }
      if (partIndex < parts.length - 1) {
        lineAttributes = op.attributes || {};
        flush();
      }
    });
  });
  if (line.length || !lines.length) flush();

  return (
    <div className="delta-content">
      {lines.map((item, index) => {
        const { header, list } = item.attributes || {};
        const contentNode = item.nodes.length ? item.nodes : '\u00a0';
        if (header) {
          const Heading = `h${Math.min(Number(header), 3)}`;
          return <Heading key={index}>{contentNode}</Heading>;
        }
        if (list) {
          return (
            <div className={`delta-list-item delta-list-${list}`} key={index}>
              <span aria-hidden="true">{list === 'ordered' ? `${index + 1}.` : '•'}</span>
              <span>{contentNode}</span>
            </div>
          );
        }
        return <p key={index}>{contentNode}</p>;
      })}
    </div>
  );
}
